import {
    createTranslatedMessageComponent,
    createUseTranslateMessage,
} from "@bloomberg/media.i18n";

import translationLabels from "./label_ids.json";

export const useTranslateMessage = createUseTranslateMessage(translationLabels);

export const TranslatedMessage =
    createTranslatedMessageComponent(translationLabels);
